import React, { useContext, useEffect, useMemo, useState } from 'react'
import useJournalCell from '../../tablecells/Journal'
import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../../context/ThemeContext';
import NoDataTable from '../../table/NoDataTable';
import { TableVirtuoso } from 'react-virtuoso';
import { getCookies } from '../../../services/Cookies';

export default function Journals() {
  const { t } = useTranslation()
  const { darkMode } = useContext(ThemeContext)
  const columns = useJournalCell()
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [journalData, setJournalData] = useState([]);
  const clientId = getCookies("clientId");

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };


  useEffect(() => {
    const stored = localStorage.getItem('journalData');
    const parsed = stored ? JSON.parse(stored) : [];
    setJournalData(parsed);
  }, []);


  const sortedData = useMemo(() => {
    let filtered = [...journalData].filter(journal => journal.clientId == clientId);
    if (!sortConfig.key) return filtered;

    return filtered.sort((a, b) => {
      const valA = a[sortConfig.key];
      const valB = b[sortConfig.key];
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [journalData, sortConfig, clientId]);

  const Row = useMemo(() => (index, row) => {
    return (
      <>
        {columns.map((col, colIndex) => (
          <TableCell key={colIndex} sx={{ fontSize: "0.8rem", border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: "hidden", }}>
            {col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex]}
          </TableCell>
        ))}
      </>
    );
  }, [columns, darkMode, t]);

  const fixedHeaderContent = () => {
    return (
      <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}` }}>
        {columns.map((col, index) => (
          <TableCell onClick={() => handleSort(col.dataIndex)} key={index} sx={{ width: col?.width, fontSize: "0.85rem", fontWeight: 550, textTransform: "capitalize", p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, cursor: "pointer", }}>
            <TableSortLabel active={sortConfig.key === col.dataIndex} direction={sortConfig.direction}>
              {col.title}
            </TableSortLabel>

          </TableCell>
        ))}
      </TableRow>);
  }

  const VirtuosoTableComponents = {
    Table: (props) => <Table {...props} sx={{ borderCollapse: "separate", tableLayout: "fixed" }} />,
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };
  return (
    <>
      <Paper style={{ width: "100%", height: "100%", backgroundColor: darkMode ? "#151924" : "#fff", }}>
        {sortedData.length === 0 ? (
          <NoDataTable columns={columns} data={sortedData} noDataMessage={t('noData')} />
        ) : (
          <>
            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
              <TableVirtuoso data={sortedData} fixedHeaderContent={fixedHeaderContent} itemContent={Row} components={VirtuosoTableComponents} itemKey={(index, row) => row.id || `${row.time}-${index}`} />
            </Box>

          </>
        )}
      </Paper>
    </>)
}
